<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_viii"></a><span class="bold">Acknowledgements</span></h2>
<p class="noindent">All files in the National Archives are © Crown Copyright and are reproduced with permission under the terms of the Open Government Licence. Quotes from <em class="italic">Hansard</em> contain Parliamentary information licensed under the Open Parliament Licence v3.0.</p>
<p class="indent">Every attempt has been made to seek and obtain permission for copyright material used in this book. In certain cases this has not been possible. However, if we have inadvertently used copyright material without permission/acknowledgements we apologise and we will make the necessary correction at the first opportunity. The author and publisher would like to gratefully acknowledge the following for their assistance or for permission to reproduce copyright material:</p>
<p class="indent">Malcolm Atkin; Barry Attoe, Postal Museum; Charles Beck; Olivier Blanc-Brude; Hannah Dale, Cheltenham College Archives; Getty Images; Henry Hemming; Alan ‘Fred’ Judge, Military Intelligence Museum, Chicksands; Ian Kelly (Militaria); Michaela Keyserlingk; Steven Kippax; Raymond Lutz; Paul McCue; John Tepper Marlin; Royal Armouries, Leeds; Peter C. Smith for permission to use a map from his book <em class="italic">Into the Minefields</em>; and Nigel West for the Foreword.</p>
<p class="indent">I would also like to thank Claire Hopkins, Lucy May, Richard Doherty, and all the team at Pen &amp; Sword for making this book possible. Finally, to the team of dedicated care-givers at Forest Valley Terrace I want to extend a heartfelt very special thank-you for the excellent care they provided to my wife Evelyn. You exemplify all the best things that your job requires – patience, warmth, compassion, empathy – and I admire each and every one of you in more ways than I can ever express. The world needs more people like you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?3176e9ac